import egto from './reducers/egto';

export default {
    egto: {
        reducer: egto,
    },
};
